document.addEventListener('DOMContentLoaded', function () {
    $('.top_banners_slideshow').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
        swipe: false,
        draggable: false,
        touchMove: false,
        infinite: true,
        adaptiveHeight: false
    });
});

$(document).ready(function () {
    $('.brand-carousel').each(function () {
        let $carousel = $(this);
        let slidesDesktop = $carousel.data('desktop') || 4;
        let slidesTablet = $carousel.data('tablet') || 2;
        let slidesMobile = $carousel.data('mobile') || 1;
        let autoplay = $carousel.data('autoplay') || false;

        $carousel.slick({
            slidesToShow: slidesDesktop,
            slidesToScroll: 1,
            autoplay: autoplay,
            arrows: false,
            dots: true,
            appendDots: $carousel.closest('.brand-carousel-wrapper'),
            dotsClass: 'slick-dots custom-dots',
            infinite: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {slidesToShow: slidesTablet}
                },
                {
                    breakpoint: 768,
                    settings: {slidesToShow: slidesTablet}
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.1,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ]
        });
    });
});


$(document).ready(function () {
    $('.menu-drawer-slider').each(function() {
        var $this = $(this);
        var slideCount = $this.find('.slide').length;

        if (slideCount > 1) {
            $this.slick({
                slidesToShow: 1.1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                adaptiveHeight: true,
                infinite: false,
            });
        } else {
            $this.addClass('slick-disabled-single-slide');
        }
    });
});


function closeMenuDrawer(button) {
    const d = button.closest('details');
    d.classList.add('closing');
    document.body.classList.remove('overflow-hidden');
    setTimeout(() => {
        d.removeAttribute('open');
        d.classList.remove('closing');
    }, 400);
}

